import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SkillProps } from "../types/attribute/skills";
import { api } from "../services/api.service";

export const fetchSkills = createAsyncThunk<SkillProps[]>("fetch/skills", async () => {
  const data = await api.attribute.skill.getAll();
  return data.data as SkillProps[];
});

interface SkillsState {
  skills: SkillProps[];
  skill: null | SkillProps;
  loading: boolean;
  error: null | string;
}

const initialState: SkillsState = {
  skills: [],
  skill: null,
  loading: false,
  error: null,
};

export const skillsSlice = createSlice({
  name: "skills",
  initialState,
  reducers: {
    addSkill: (state, action: PayloadAction<SkillProps>) => {
      state.skills.push(action.payload);
    },
    removeSkill: (state, action: PayloadAction<{ id: number }>) => {
      state.skills = state.skills.filter(
        (skill) => skill.id !== action.payload.id
      );
    },
    updateSkill: (state, action: PayloadAction<SkillProps>) => {
      state.skills = state.skills.map((skill) =>
        skill.id === action.payload.id ? action.payload : skill
      );
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchSkills.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSkills.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        state.skills = action.payload;
      })
      .addCase(fetchSkills.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      });
  },
});

export const { addSkill, removeSkill, updateSkill } = skillsSlice.actions;

export default skillsSlice.reducer;
